/* eslint-disable no-undef */
import { initializeApp } from 'firebase/app'

import { getAuth } from 'firebase/auth'
import { getDatabase } from 'firebase/database'
import { getMessaging, isSupported } from 'firebase/messaging'
import { getStorage } from 'firebase/storage'

let firebaseApp       = null
let firebaseDatabase  = null
let firebaseStorage   = null
let firebaseAuth      = null
let firebaseMessaging = null

if (process.env.REACT_APP_API_KEY) {
  // Initialize Firebase
  firebaseApp = initializeApp({
    apiKey: process.env.REACT_APP_API_KEY,
    authDomain: process.env.REACT_APP_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_DATABASE_URL,
    projectId: process.env.REACT_APP_PROJECT_ID,
    storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_APP_ID,
    measurementId: process.env.REACT_APP_MEASUREMENT_ID
  })

  firebaseAuth      = getAuth(firebaseApp)
  firebaseDatabase  = getDatabase(firebaseApp)
  firebaseStorage   = getStorage(firebaseApp)
  firebaseMessaging = isSupported() ? getMessaging(firebaseApp) : null
}
export {
  firebaseApp,
  firebaseDatabase,
  firebaseStorage,
  firebaseAuth,
  firebaseMessaging
}
